const isNullOrWhitespace = ( input ) => {
    return !input || !input.trim();
}

export {isNullOrWhitespace}
